import { FormItem, ISelectOption, Select, SelectMini } from '@salecycle/ui-component-library';
import { entityToSortedSelectOptions } from 'components/utils/getSelectOptions';
import { useClients } from 'core/app/AppContext';
import { useTranslation } from 'react-i18next';
import { Site } from 'sections/client-management/entities';
import styled from 'styled-components';

interface IProps {
  isMini: boolean;
}
const Container = styled.div<IProps>`
  ${props => (props.isMini ? '' : 'width: 300px;')}
`;

export function SiteSelect({ siteId, onSiteChanged, isMini }) {
  const { getSites } = useClients();
  const { t } = useTranslation('components');

  const sites: ISelectOption<string>[] = entityToSortedSelectOptions<Site>(getSites());

  const handleSiteChange = (option: ISelectOption<string>) => {
    if (option?.value) {
      onSiteChanged(option.value);
    }
  };
  //Find the ISelectOption associated with this siteId
  const siteValue = sites.find(site => site.value === siteId);
  const inputId = 'site-select';

  return (
    <Container isMini={isMini} data-testid="SiteSelectContainer">
      <FormItem
        isMini={isMini}
        spacingBelow={false}
        label={`${t('siteSelect.label')}${isMini ? ':' : ''}`}
        for={inputId}
      >
        {isMini ? (
          <SelectMini
            ariaLabel={t('siteSelect.aria')}
            options={sites}
            isSorted={true}
            searchable={true}
            minLength={2}
            onChange={handleSiteChange}
            value={siteValue}
            placeholder={t('siteSelect.placeholder')}
            // TODO:AMAX needs an inputId prop to allow label targetting
          />
        ) : (
          <Select
            ariaLabel={t('siteSelect.aria')}
            options={sites}
            isSorted={true}
            searchable={true}
            minLength={2}
            onChange={handleSiteChange}
            value={siteValue}
            placeholder={t('siteSelect.placeholder')}
            inputId={inputId}
          />
        )}
      </FormItem>
    </Container>
  );
}
